import type { GiftCardConfig } from '#types/config/components/form/giftCard'
import type { RecursivePartial } from '#types/utils'

export default {
  checkboxSize: 'sm'
} satisfies RecursivePartial<GiftCardConfig>
